import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c8c3d02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex-1f d-flex-column page" }
const _hoisted_2 = { class: "body d-flex-1f" }
const _hoisted_3 = { class: "bottom-wrap" }

import { onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import { updatePhone } from "@/api/userApi";
import { reSessionUser } from "@/modular/Session";
import { Toast as toast } from 'vant';
import { AddUser, sendPhoneVerifCode, verifResult } from "@/api/userApi";

const _sendText = "发送验证码";



export default /*#__PURE__*/_defineComponent({
  __name: 'Phone',
  setup(__props) {

const router = useRouter();

onMounted(() => {
    initData();
});

function initData() {
    form.value.phone = "";
    form.value.sms = "";
    countDown.value = -1;
    sendText.value = _sendText;
    lockSendSms.value = false;
}
async function sendSms() {
    if (lockSendSms.value) {
        return;
    }
    lockSendSms.value = true;
    try {
        if (!/^\d{11}$/.test(form.value.phone)) {
            lockSendSms.value = false;
            toast.fail("请输入正确的手机号码");
            return;
        }

        phoneVerifCodeReqModel.value.phone = form.value.phone;
        var isOK = await sendPhoneVerifCode(
            phoneVerifCodeReqModel.value
        );
        if (!isOK) {
            toast.fail("发送失败");
            return;
        }
        // 发送成功后
        countDown.value = 120;
        updateTime();
    } catch (error) {
        lockSendSms.value = false;
    }
}
function updateTime() {
    countDown.value--;
    sendText.value = `${countDown.value}秒后可再次获取`;
    if (countDown.value <= 0) {
        sendText.value = _sendText;
        lockSendSms.value = false;
        return;
    }
    setTimeout(updateTime, 1000);
}
async function savePhone() {
    toast.loading({});

    phoneVerifCodeReqModel.value.phone = form.value.phone;
    phoneVerifCodeReqModel.value.code = form.value.sms;
    var key = await verifResult(phoneVerifCodeReqModel.value);
    if (!key) {
        toast.fail("验证失败");
        return;
    }
    var isOK = await updatePhone(form.value.phone);
    if (!isOK) {
        toast.fail("验证失败");
    }
    countDown.value = -1; // 使倒计时停止
    await reSessionUser(); // 刷新vuex用户会话数据

    toast.success("修改成功");
    router.back();
}





let lockSendSms = ref(false)
let countDown = ref(0)
let sendText = ref(_sendText)
let form = ref({ phone: "", sms: '' })
let formRules = ref({
    phone: [
        { required: true, message: "请输入手机号码" },
        { pattern: /^[\d]{11}$/, message: "请输入正确的手机号码" },
    ] as FieldRule[],
    sms: [
        { required: true, message: "请输入验证码" },
        { pattern: /^[\d]{6}$/, message: "请输入正确验证码" },
    ] as FieldRule[],
})
let phoneVerifCodeReqModel = ref({
    purpose: 6,
    phone: "",
    code: "",
})

return (_ctx: any,_cache: any) => {
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_form, {
      onSubmit: savePhone,
      class: "d-flex-1f d-flex-column siez-large"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_van_field, {
            label: "手机号",
            border: false,
            readonly: ""
          }),
          _createVNode(_component_van_field, {
            modelValue: _unref(form).phone,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).phone) = $event)),
            clickable: true,
            type: "tel",
            maxlength: "11",
            placeholder: "请填写手机号码",
            rules: _unref(formRules).phone
          }, null, 8, ["modelValue", "rules"]),
          _createVNode(_component_van_field, {
            label: "验证码",
            border: false,
            readonly: ""
          }, {
            button: _withCtx(() => [
              _createElementVNode("span", {
                class: "send-sms",
                onClick: sendSms
              }, _toDisplayString(_unref(sendText)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_van_field, {
            modelValue: _unref(form).sms,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).sms) = $event)),
            border: true,
            clickable: "",
            center: "",
            clearable: "",
            type: "number",
            maxlength: "6",
            placeholder: "请输入短信验证码",
            rules: _unref(formRules).sms
          }, null, 8, ["modelValue", "rules"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_van_button, {
            class: "btn",
            size: "large",
            block: "",
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})